import types from "./actionTypes";
import LoaderActions from "./loaderActions";
import Customers from "../../services/customers";
import Tridion from "../../services/tridion";
import Constants from "../../common/constants";

class CustomerActions {
	static search(firstName, lastName, email) {
		return async function (dispatch) {
			dispatch(LoaderActions.startAsyncCall());
			try {
				const customers = await Customers.search(firstName, lastName, email);
				dispatch(CustomerActions._setCustomers(customers));
			} catch (error) {
				dispatch(LoaderActions.errorAsyncCall());
				throw error;
			}
		};
	}

	static getPreferredDealer(uuid, brand) {
		return async function (dispatch) {
			dispatch(LoaderActions.startAsyncCall());
			try {
				const preferredDealer = await Customers.getPreferredDealer(uuid, brand);
				dispatch(CustomerActions._setCustomerPreferredDealer(uuid, brand, preferredDealer));
			} catch (error) {
				if (error.status === Constants.STATUS_CODE.NOT_FOUND) {
					dispatch(CustomerActions._setCustomerPreferredDealer(uuid, brand));
				}
				dispatch(LoaderActions.errorAsyncCall());
				throw error;
			}
		};
	}

	static getShowVOTOrderId(uuid, lc, brand) {
		return async function (dispatch) {
			dispatch(LoaderActions.startAsyncCall());
			try {
				let content;
				if (brand === Constants.BRANDS.TOYOTA) {
					content = await Tridion.getDashboardContent(lc, brand);
				} else if (brand === Constants.BRANDS.LEXUS) {
					content = await Tridion.getConfiguration(lc, brand);
				}

				dispatch(CustomerActions._setShowVOTOrderId(uuid, brand, content));
			} catch (error) {
				dispatch(LoaderActions.errorAsyncCall());
				throw error;
			}
		};
	}

	static getVehicles(uuid) {
		return async function (dispatch) {
			dispatch(LoaderActions.startAsyncCall());
			try {
				const vehicles = await Customers.getVehiclesByUuid(uuid);
				dispatch(CustomerActions._setCustomerVehicles(uuid, vehicles));
			} catch (error) {
				dispatch(LoaderActions.errorAsyncCall());
				throw error;
			}
		};
	}

	static getVehicleSubscriptions(uuid, vin, deviceId) {
		return async function (dispatch) {
			dispatch(LoaderActions.startAsyncCall());
			try {
				const vehicleSubscriptions = await Customers.getSubscriptionsByDeviceId(deviceId);
				const subscriptions = vehicleSubscriptions[deviceId] && vehicleSubscriptions[deviceId].subscription;

				dispatch(CustomerActions._setCustomerVehicleSubscriptions(uuid, vin, subscriptions));
			} catch (error) {
				dispatch(LoaderActions.errorAsyncCall());
				throw error;
			}
		};
	}

	static getOrders(uuid, brand) {
		return async function (dispatch) {
			dispatch(LoaderActions.startAsyncCall());
			try {
				const orders = await Customers.getOrdersByUuid(uuid, brand);
				dispatch(CustomerActions._setCustomerOrders(uuid, orders));
			} catch (error) {
				dispatch(CustomerActions._setCustomerOrders(uuid));
				dispatch(LoaderActions.errorAsyncCall());
				throw error;
			}
		};
	}

	static getOrderDetails(uuid, orderId) {
		return async function (dispatch) {
			dispatch(LoaderActions.startAsyncCall());
			try {
				const orderDetails = await Customers.getOrderDetails(orderId);
				dispatch(CustomerActions._setCustomerOrderDetails(uuid, orderId, orderDetails));
			} catch (error) {
				dispatch(CustomerActions._setCustomerOrderDetails(uuid, orderId));
				dispatch(LoaderActions.errorAsyncCall());
				throw error;
			}
		};
	}

	static getGroups(uuid) {
		return async function (dispatch) {
			try {
				const data = await Customers.getGroups(uuid);
				const groups = data.groups;
				dispatch(CustomerActions._setCustomerGroups(uuid, groups));
			} catch (error) {
				dispatch(CustomerActions._setCustomerGroups(uuid));
				dispatch(LoaderActions.errorAsyncCall());
				throw error;
			}
		};
	}

	static activateDealerRole(customer) {
		const { uuid, firstName, lastName, email } = customer;
		return async function (dispatch) {
			try {
				const data = await Customers.getGroups(uuid);
				const groups = data.groups;
				groups.push(`DEALER`);
				const customers = await Customers.search(firstName, lastName, email);
				dispatch(CustomerActions._setCustomers(customers));
				
				dispatch(CustomerActions._setCustomerGroups(uuid, groups));
			} catch (error) {
				dispatch(CustomerActions._setCustomerGroups(uuid));
				dispatch(LoaderActions.errorAsyncCall());
				throw error;
			}
		};
	}

	static sort(field, order) {
		return {
			type: types.CUSTOMERS.SORT,
			sortBy: {
				field,
				order
			}
		};
	}

	static changeCulture(uuid,newCulture){
		return {
			type: types.CUSTOMERS.CHANGE_CULTURE,
			data: {
				uuid,
				newCulture
			}
		};
	}

	static _setCustomerVehicleSubscriptions(uuid, vin, subscriptions) {
		return {
			type: types.CUSTOMERS.SET_SUBSCRIPTIONS,
			data: {
				uuid,
				vin,
				subscriptions
			}
		};
	}

	static _setCustomerVehicles(uuid, vehicles) {
		return {
			type: types.CUSTOMERS.SET_VEHICLES,
			data: {
				uuid,
				vehicles
			}
		};
	}

	static _setCustomerOrders(uuid, orders) {
		return {
			type: types.CUSTOMERS.SET_ORDERS,
			data: {
				uuid,
				orders
			}
		};
	}

	static _setCustomerOrderDetails(uuid, orderId, orderDetails) {
		return {
			type: types.CUSTOMERS.SET_ORDER_DETAILS,
			data: {
				uuid,
				orderId,
				orderDetails
			}
		};
	}

	static _setCustomers(customers) {
		return {
			type: types.CUSTOMERS.SET,
			customers
		};
	}

	static _setShowVOTOrderId(uuid, brand, content) {
		return {
			type: types.CUSTOMERS.SET_SHOW_VOT_ORDER_ID,
			data: {
				uuid,
				brand,
				content
			}
		};
	}

	static _setCustomerPreferredDealer(uuid, brand, preferredDealer) {
		return {
			type: types.CUSTOMERS.SET_PREFERRED_DEALER,
			data: {
				uuid,
				brand,
				preferredDealer
			}
		};
	}

	static _setCustomerGroups(uuid, groups) {
		return {
			type: types.CUSTOMERS.SET_GROUPS,
			data: {
				uuid,
				groups
			}
		};
	}
}
export default CustomerActions;